$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  let url = "";
  let status = 1;

  if (
    (p === "top_product_group" || p === "deactivated_top_product_group") &&
    a === "list"
  ) {
    $(document).on("submit", "#search-form", function (e) {
      e.preventDefault();

      let search_string = $("#search_string").val();
      let location_id = $("body").attr("event_id");
      if (p === "top_product_group") {
        status = 1;
      }
      if (p === "deactivated_top_product_group") {
        status = 2;
      }
      searchTopProductGroup(location_id, search_string, status);
    });

    function searchTopProductGroup(location_id, search_string, status) {
      $.ajax({
        type: "POST",
        url: "/ajax/top_product_group/search",
        data: {
          location_id,
          search_string,
          status,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $("#search-button").attr("data-search-string", search_string);
            $("#top-product-group-list-view").empty();
            $("#top-product-group-list-view").append(data.html);
          }
          $("html,body").scrollTop(0);
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }
  }
});
